import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import AttributeItem from 'dashboard/components/AttributeItem';
import { UppercaseLabel } from 'dashboard/components/Typography';
import { HydratedEmailSim } from 'dashboard/models/graph-hydration';

const SectionTitle = styled(UppercaseLabel)`
  color: ${Color.CoreSlate900};
`;

const AttributesColumn = styled('div')`
  display: grid;
  grid-row-gap: ${Spacing[4]};
`;

interface GraphHoverCardEmailSimilarityProps {
  hydratedEmailSimilarity: HydratedEmailSim;
}

const GraphHoverCardEmailSimilarity = ({
  hydratedEmailSimilarity,
}: GraphHoverCardEmailSimilarityProps) => {
  const serverHydratedEmailSimilarity = hydratedEmailSimilarity.hydrationData;
  const {
    account1: { id: _account1Id, email: account1Email },
    account2: { id: _account2Id, email: account2Email },
  } = serverHydratedEmailSimilarity.details;
  return (
    <>
      <SectionTitle>
        Email Similarity: {hydratedEmailSimilarity.hydrationData['display-name']}
      </SectionTitle>
      <AttributesColumn>
        <AttributeItem
          title='Matched Criteria'
          value={hydratedEmailSimilarity.hydrationData.criteria.join(', ')}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-email-sim-hover-criteria'
        />
        <AttributeItem
          title='Matched Emails'
          value={account1Email + ', ' + account2Email}
          isRedacted={false}
          wordBreak='break-all'
          placeholder='-'
          dataTest='graph-email-sim-hover-emails'
        />
      </AttributesColumn>
    </>
  );
};

export default GraphHoverCardEmailSimilarity;
